import React, { useEffect, useState, useCallback, useMemo } from "react";
import { useNavigate } from "react-router-dom";
import { handlingCatchError } from "../../../Utils/ErrorHandling";
import {
  Table,
  TableBody,
  TableCell,
  TableRow,
  TableContainer,
  Paper,
  TablePagination,
  TableHead,
  TextField,
  Switch,
} from "@mui/material";
import moment from "moment";
import ArrowDownwardOutlinedIcon from "@mui/icons-material/ArrowDownwardOutlined";
import ArrowUpwardOutlinedIcon from "@mui/icons-material/ArrowUpwardOutlined";
import DeleteOutlinedIcon from "@mui/icons-material/DeleteOutlined";
import MenuItem from "@mui/material/MenuItem";
import { CommonSearchFunction } from "../../../helpers/dataHelper";
import InfoModal from "../../../helpers/CommonModal/InfoModal";
import Snackbar from "@mui/material/Snackbar";
import MuiAlert from "@mui/material/Alert";
import { set } from "react-hook-form";
import { apiCommonTrigger } from "../../../Utils/apiServicehelper";
import { Config } from "../../../Utils/Config";

const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

const AdminLandingPage = (props) => {
  const [searchData, setSearchData] = useState([]); // To store API response
  const [modalOpen, setIsModalOpen] = useState(false); // To store API response
  const [modalHeader, setModalHeader] = useState(false); // To store API response
  const [modalContent, setModalContentType] = useState(false); // To store API response
  const [selectedUser, setSelectedUser] = useState(null); // To store API response
  const [open, setOpen] = useState(false); // To Enable/Disable Snackbar
  const [snackClr, setSnackClr] = React.useState("");
  const [snackMsg, setSnackMsg] = React.useState("");

  const navigate = useNavigate();
  const [data, setData] = useState([]);
  const [paginationData, setPaginationData] = useState({ totalrecords: 0 });
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [rowsPerPage, setRowsPerPage] = useState(25);
  const [page, setPage] = useState(0);
  const [orderBy, setOrderBy] = useState("createddate");
  const [sortDirection, setSortDirection] = useState("DESC");
  const [searchedText, setSearchedText] = useState("");
  const searchedFieldsString = ["email", "firstname", "lastname"];
  const userData = JSON.parse(localStorage.getItem("user") || "null");
  const [loading2fa,setLoading2fa]=useState(true);
  useEffect(() => {
    if (!searchedText) {
      setSearchData([]); // Reset search results when clearing input
    }
  }, [data, searchedText]);

  const handleChange = (e) => {
    let { name, value } = e.target;

    if (name === "searchField") {
      setPage(0);
      setSearchedText(value);
      if (value.trim().length > 0) {
        const result = CommonSearchFunction(value, data, searchedFieldsString);
        if (result.data.length > 0) {
          setSearchData(result.data);
        } else {
          setSearchData([]); // No matches, clear searchData
        }
      } else {
        setSearchData([]); // Input cleared, reset searchData
      }
    }
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  const fetchData = useCallback(async () => {
    if (!userData || !userData.token) {
        console.warn("Missing user token, skipping API call.");
        setError("No token found");
        setLoading(false);
        return;
    }

    try {
        setLoading(true);
        setError(null); // Reset error before making API call
        let inputData={page: page + 1,
                resultsperpage: rowsPerPage,
                keyword: searchedText || "",
                orderBy,
                orderDirection: sortDirection}
        const res = await apiCommonTrigger("post",`${Config.API_URL}/admin/users`,inputData)
        if (res.status === 200 && res.data && res.data.users) {
          setError(null);  // This should clear the error if data is received
          setData(res.data.users);
          setPaginationData(res.data.pagination);
          setSearchData([]); // Reset search if no keyword
      } else {
          console.warn("Unexpected API response:", res);
          setError("Unexpected API response");
      }
    } catch (error) {
      console.error("Fetch Data Error:", error);
      setError("Error fetching data");
      handlingCatchError(error);
  } finally {
        setLoading(false);
    }
}, [page, rowsPerPage, searchedText, orderBy, sortDirection]);

useEffect(() => {
  fetchData();
}, [fetchData]);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleSorting = (column) => {
    if (orderBy === column) {
    setSortDirection(sortDirection === "ASC" ? "DESC" : "ASC");
    } else {
    setOrderBy(column);
    setSortDirection("ASC");
    }
    };

  const deleteUser = () => {
    apiCommonTrigger("delete" , Config.API_URL + "/admin/delete/" , [selectedUser.userid])
      .then((res) => {
        if (res.status === 200) {
          setOpen(true);
          setSnackClr("success");
          setSnackMsg("User deleted successfully");
          fetchData();
        } else {
          handlingCatchError(res, navigate);
        }
      })
      .catch((err) => {
        handlingCatchError(err, navigate);
      });
  };

  const impersonateSignin = () => {
    setLoading(true);
    let inputData={userid: selectedUser.userid};
     apiCommonTrigger("post",`${Config.API_URL}/admin/impersonate`,inputData)
      .then((res) => {
        if (res.status === 200) {
          setLoading(false);
          localStorage.setItem("accessKey", res.data.token);
          localStorage.removeItem("isAdmin");
          localStorage.setItem("user", JSON.stringify(res.data));
          localStorage.setItem("impersonated", res.data.impersonated);
          navigate("/market-search");
        } else {
          setLoading(false);
          handlingCatchError(res, navigate);
        }
      })
      .catch((err) => {
        setLoading(false);
        handlingCatchError(err, navigate);
      });
  };const sortedData = useMemo(() => {
    return [...data].sort((a, b) => {
    const order = sortDirection === "DESC" ? -1 : 1;
    
    if (orderBy === "createddate" || orderBy === "logindate") {
    const dateA = a[orderBy] ? new Date(a[orderBy]).getTime() : null;
    const dateB = b[orderBy] ? new Date(b[orderBy]).getTime() : null;
    
    if (dateA === null && dateB === null) return 0; 
    if (dateA === null) return sortDirection === "DESC" ? -1 : 1;
    if (dateB === null) return sortDirection === "DESC" ? 1 : -1; 
    
    return (dateA - dateB) * order;
    }
    
    return a[orderBy]?.localeCompare(b[orderBy]) * order || 0;
    });
    }, [data, sortDirection, orderBy]);
    

  const tableHeaders = [
    { label: "First Name", key: "firstname", sorting: true },
    { label: "Last Name", key: "lastname", sorting: true },
    { label: "Email", key: "email" },
    { label: "Company", key: "company" },
    { label: "Phone", key: "phone" },
    { label: "Created Date", key: "createddate", sorting: true },
    { label: "Last Login", key: "logindate", sorting: true },
    { label: "2FA", key:"enable2fa"},
    { label: "User Logo", key: "showuserlogo", sorting: false },
    { label: "View/Update", key: "view" },
    { label: "Login as", key: "login" },
    { label: "Delete", key: "delete" },
  ];

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }

    setOpen(false);
  };

  const filteredUsers = useMemo(() => {
    if (searchedText.trim().length > 0 && searchData.length > 0) {
      return searchData;
    }
    return data || []; // Ensure it returns an array
  }, [searchedText, searchData, data]);

const isSearchDataAvailable = () => !!searchData?.length;



const handle2faAuthToggle=(userid)=> async (event)=>{
  const useSearchData=isSearchDataAvailable();
  const sourceData = useSearchData ? searchData : data;
  if (sourceData.some((ele) => ele?.loading)) return;
  const value = event.target.checked;
  updateUserList(useSearchData,userid,{loading2fa:true,enable2fa:value})

  try{
    
    const res = await apiCommonTrigger("post",`${Config.API_URL}/admin/enable-2fa`,{userid: userid,
      is2faenabled: value});
    if(res.status === 200){
      setOpen(true);
      setSnackClr("success");
      setSnackMsg("Updated successfully");
      fetchData();
      handle2faResponse(useSearchData,userid, value);
    } else {
      handle2faResponse(useSearchData,userid, !value);
      handlingCatchError(res);
    }
  }
  catch (err) {
    handle2faResponse(useSearchData,userid, !value);
      handlingCatchError(err);
  }
}
const handleChangeToggle = (selectedUser) => async (event) => {
  const useSearchData = isSearchDataAvailable();
  const sourceData = useSearchData ? searchData : data;
  if (sourceData.some((ele) => ele?.loading)) return;

  const value = event?.target?.checked;

  updateUserList(useSearchData, selectedUser.userid, { loading: true, showuserlogo: value });
   let inputData={userid: selectedUser.userid,
        showuserlogo: value,}
  try {
    const res = await apiCommonTrigger("post",`${Config.API_URL}/admin/updateuserlogo`,inputData)

    if (res.status === 200) {
      setOpen(true);
      setSnackClr("success");
      setSnackMsg("Updated successfully");
      fetchData();
      handleCatchResponse(useSearchData, selectedUser.userid, value);
    } else {
      handleCatchResponse(useSearchData, selectedUser.userid, !value);
      handlingCatchError(res);
    }
  } catch (err) {
    handleCatchResponse(useSearchData, selectedUser.userid, !value);
      handlingCatchError(err);
  }
};

const handleCatchResponse = (useSearchData, userid, fallbackValue = null) => {
  updateUserList(useSearchData, userid, {
    loading: false,
    ...(fallbackValue !== null && { showuserlogo: fallbackValue }),
  });
};
const handle2faResponse = (useSearchData, userid, fallbackValue = null) => {
  updateUserList(useSearchData, userid, {
    loading2fa: false,
    ...(fallbackValue !== null && { is2faenabled: fallbackValue }),
  });
};

const updateUserList = (useSearchData, userid, updates) => {
  const source = useSearchData ? searchData : data;
  const updated = source.map((item) =>
    item.userid === userid ? { ...item, ...updates } : item
  );
  useSearchData ? setSearchData(updated) : setData(updated);
};


const dynamicClassName = filteredUsers.length === 1 ? "single-record" : ""
  return (
    <div className="common-table user-management">
      {loading && (
        <div className="loader-wrap">
          <div className="loading"></div>
        </div>
      )}
      {error && <div className="error-message">{error}</div>}

      <div className="top-heading">
        <h2>Users Management</h2>

        <div className="search_btn_align_right">
          <TextField
            name={"searchField"}
            label="Search"
            type="text"
            value={searchedText}
            onChange={handleChange}
            className="textbox-custom"
          />
          <button
            onClick={() => {
              setIsModalOpen(true);
              setModalHeader("Create user");
              setModalContentType("create-us");
            
            }}
          >
           
            Create User
          </button>
        </div>

        <div></div>
      </div>

      <div className="my-markets-table fav_table">
        <TableContainer
          component={Paper}
          style={{ overflowX: "initial" }}
          className="table-design"
        >
          <Table sx={{ minWidth: 650 }} aria-label="simple table" stickyHeader>
            <TableHead>
              <TableRow>
              {tableHeaders.map(({ label, key, sorting }) => (
  <TableCell key={key} align="left">
    <span
      onClick={() => sorting && handleSorting(key)}
      style={{
        cursor: sorting ? "pointer" : "default",
        fontWeight: orderBy === key ? "bold" : "",
      }}
    >
    {label === "2FA" ? (
  <span className="ms-3">{label}</span>
) : (
  label
)}

      {sorting &&
        (orderBy === key ? (
          sortDirection === "ASC" ? (
            <ArrowUpwardOutlinedIcon fontSize="small" />
          ) : (
            <ArrowDownwardOutlinedIcon fontSize="small" />
          )
        ) : (
          <ArrowDownwardOutlinedIcon
            fontSize="small"
            style={{ opacity: 0.3 }}
          />
        ))}
    </span>
  </TableCell>
))}

              </TableRow>
            </TableHead>
            <TableBody>
              {filteredUsers.length > 0 ? (
                filteredUsers.map((user, id) => (
                  <TableRow key={id}>
                    <TableCell align="left">{user.firstname || "-"}</TableCell>
                    <TableCell align="left">{user.lastname || "-"}</TableCell>
                    <TableCell align="left">{user.email || "-"}</TableCell>
                    <TableCell align="left">{user.company || "-"}</TableCell>
                    <TableCell align="left">{user.phone || "-"}</TableCell>
                    <TableCell align="left">
                      {user.createddate
                        ? moment(user.createddate).format("DD-MMM-YYYY")
                        : "-"}
                    </TableCell>
                    <TableCell align="left">
                      {user.logindate
                        ? moment(user.logindate).format("DD-MMM-YYYY")
                        : "-"}
                    </TableCell>
                    <TableCell align="left">
                         <div style={{ height: "40px", display: "flex", alignItems: "center" }}>
                      {user.loading2fa &&
                         <div className={`code-loader toggle ${dynamicClassName}`}> </div>
                      }
                      {!user?.loading2fa &&  
                      <Switch
                          checked={user?.is2faenabled ? true : false}
                          id={"available-amenities-2fa"}                          
                          onChange={handle2faAuthToggle(user.userid)}
                          className="switcher_btn"
                        />}
                      </div>
                    </TableCell>
                    <TableCell align="left">
                       <div style={{ height: "40px", display: "flex", alignItems: "center" }}>
                      {user.loading &&
                         <div className={`code-loader toggle ${dynamicClassName}`}> </div>
                      }
                      {!user?.loading &&  
                      <Switch
                          checked={user?.showuserlogo ? true : false}
                          id={"available-amenities"}                          
                          onChange={handleChangeToggle(user)}
                          className="switcher_btn"
                        />}
                      </div>
                    </TableCell>

                    <TableCell align="left">
                      <button className="view-update-btn admin" onClick={()=>navigate(`/admin/user-account/${user.userid}`)}>View/Update</button>
                    </TableCell>
                    <TableCell align="left">
                      <button className="login-as-btn admin"
                        onClick={() => {
                          setIsModalOpen(true);
                          setModalHeader("Login as User");
                          setModalContentType("login-as");
                          setSelectedUser(user);
                        }}
                      >
                        Login As
                      </button>
                    </TableCell>
                    <TableCell align="left" className="three-dots">
                      <MenuItem
                        onClick={() => {
                          setIsModalOpen(true);
                          setModalHeader("Are you sure you want to delete?");
                          setModalContentType("delete-btn");
                          setSelectedUser(user);
                        }}
                        className="delete-option"
                      >
                        <DeleteOutlinedIcon />
                      </MenuItem>
                    </TableCell>
                  </TableRow>
                ))
              ) : (
                <TableRow>
                  <TableCell align="center" colSpan={tableHeaders.length} style={{ textAlign: "center" }} className="store-no-data">
                    No records found
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
      </div>

      {data.length > 0 && (
        <TablePagination
          rowsPerPageOptions={[25, 50, 100]}
          component="div"
          count={paginationData?.totalrecords || 0}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      )}

      <InfoModal
        isOpen={modalOpen}
        header={modalHeader}
        contentType={modalContent}
        onClose={closeModal}
        deleteUser={deleteUser}
        impersonateSignin={impersonateSignin}
        package={props.packDetails}
        fetchData={fetchData}
      />
     
      <Snackbar
        open={open}
        autoHideDuration={2000}
        onClose={handleClose}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert onClose={handleClose} severity={snackClr} sx={{ width: "100%" }}>
          {snackMsg}
        </Alert>
      </Snackbar>
    </div>
  );
};

export default AdminLandingPage;